import React from "react";
import { BrandMark } from "@/components/BrandMark";
import N8Emblem from "@/components/N8Emblem";

// N8One-owned Google OAuth. The backend handles the full server-side
// authorization-code flow — the button just sends the browser to
// /api/auth/google/start. When the app is running inside an iframe (the
// Emergent preview dashboard, an embedded webview, etc.) we navigate the
// TOP-level window instead, because Google refuses to render its sign-in
// page in any iframe (X-Frame-Options: DENY).
export default function Login() {
  const handleSignIn = () => {
    const startUrl = `${window.location.origin}/api/auth/google/start`;
    try {
      const inIframe = window.self !== window.top;
      if (inIframe && window.top) {
        // Cross-origin writes to window.top.location are permitted; reads
        // are what the browser blocks. This escapes the Emergent iframe
        // so the OAuth flow runs at the top level.
        window.top.location.href = startUrl;
        return;
      }
    } catch {
      // Access to window.top denied — fall through to open in a new tab
      // so the flow still leaves the iframe context.
      window.open(startUrl, "_blank", "noopener,noreferrer");
      return;
    }
    window.location.href = startUrl;
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "linear-gradient(180deg, #f6f1e7 0%, #ecdfc9 100%)" }}
    >
      <div className="max-w-md w-full text-center">
        <div className="mb-6 flex justify-center" data-testid="login-emblem-wrap">
          <N8Emblem
            mode="full"
            size={132}
            ariaLabel="N8ONE emblem"
            testid="login-emblem"
          />
        </div>
        <div className="mb-6 flex justify-center">
          <BrandMark className="text-4xl sm:text-5xl" testid="login-brand-wordmark" />
        </div>
        <div className="text-[10px] tracking-[0.32em] uppercase mb-6 opacity-60" style={{ color: "#3a2f24" }}>
          The Art Of Becoming
        </div>
        <h1 className="text-4xl sm:text-5xl font-serif mb-4" style={{ color: "#3a2f24" }}>
          Welcome home.
        </h1>
        <p className="text-base opacity-80 mb-10" style={{ color: "#3a2f24" }}>
          Tap into your innate ability to reflect, grow, and become who you’re meant to be.
        </p>
        <button
          data-testid="login-google-button"
          onClick={handleSignIn}
          className="w-full py-4 rounded-full text-base tracking-wide transition hover:opacity-90"
          style={{ background: "#3a2f24", color: "#f6f1e7" }}
        >
          Continue with Google
        </button>
        <p
          className="text-xs opacity-70 mt-8 leading-relaxed"
          style={{ color: "#3a2f24" }}
          data-testid="login-legal-consent"
        >
          By continuing, you agree to N8One&rsquo;s{" "}
          <a
            href="/legal/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:opacity-80"
            data-testid="login-terms-link"
          >
            Terms &amp; Conditions
          </a>{" "}
          and acknowledge the{" "}
          <a
            href="/legal/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4 hover:opacity-80"
            data-testid="login-privacy-link"
          >
            Privacy Policy
          </a>.
        </p>
      </div>
    </div>
  );
}
